import { createListSelector } from 'redux/utils'

export const selectFavouriteData = createListSelector('Favourite')
